// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0e10d6a1","453":"52cc4f13","455":"17608301","977":"b27c407c"}[chunkId] + ".chunk.js";
};